/**
 * Returns the number, excluding cents,
 * of an edited text input.
 *
 * - Example (number value is 20):
 *
 * R$ 20,00 -> insert 1 = 201
 * R$ 20,00 -> deletion = 2
 *
 * NOTE: The limit of this algorithm is the size in bytes of
 * `Number` in javascript. After, the limit is reached
 * there will be only zeros.
 */
export const inputTextToMoneyOnlyUnits = (text) => {
  const [unit, _cents] = text.split(/\,/);
  const cents = (_cents || "").replace(/\D/g, "");
  const deletion = cents.length < 2;
  const unitValue = unit.replace(/\D/g, "") || "";
  const inCentsPosition = cents.slice(2, cents.length);
  return (
    parseFloat(
      unitValue
        .slice(0, unitValue.length - Number(deletion))
        .concat(inCentsPosition)
    ) || 0
  );
};

export const inputCurrencyTextToFloat = (text) => {
  const currency = text.replace(/\D/g, "");
  return parseFloat(currency) / 100 || 0;
};



// WEBPACK FOOTER //
// ./src/libs/money.js